import React from 'react';
import { SkeletonLoader } from '../Common';

function LoaderHoc({ isLoading, children }) {
  if (isLoading) {
    return <SkeletonLoader />;
  }
  return children;
}

export default LoaderHoc;
